/** Textes « app » — le français fait foi. */
export const app = {
  monMotDePasse: 'Mon mot de passe',
  seDeconnecter: 'Se déconnecter',
  pointsARegarder: (n: number) => `${n} point(s) à regarder`,
  refuseTitre: 'Cet écran ne vous est pas ouvert',
  refuseAnalyses: 'Les analyses et le suivi sont réservés aux gérants. Votre poste est celui du comptoir : la file du jour, les disponibilités et les encaissements.',
  refuseDroit: "Cet écran demande un droit que votre compte n'a pas. Demandez-le au gérant · finances, qui gère les comptes et les droits.",
  revenirTaches: 'Revenir à mes tâches',
  serveurTitre: 'Le serveur ne répond pas',
  serveurConnecte: 'Vous êtes toujours connecté — ',
  serveurPasLaPeine: "ce n'est pas la peine de vous identifier à nouveau",
  serveurInjoignable: ". Le logiciel n'arrive simplement pas à joindre le serveur pour le moment.",
  serveurVerifiez: "Vérifiez votre connexion. Si elle fonctionne, c'est le serveur de l'agence qui est momentanément indisponible. ",
  serveurAucunePerte: "Aucune de vos données n'est perdue.",
  titreDocument: (marque: string) => `${marque} — Gestion de location`,
};
